export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13667.aec76f4b.jpg";